import React, {Component} from 'react';
import {
  Layout,
  Card,
  SkeletonBodyText,
} from '@shopify/polaris';

import Container from 'components/Container';
import {getUser} from 'api/user';

const styles = {
  iframe: {
    border: 'none',
    width: '100%',
    height: 1000
  }
}
class Debug extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
    };
  }

  componentDidMount() {
    getUser().then(user => {
      this.setState({user});
    });
  }

  render() {
    const { user } = this.state;
    if (!user) {
      return <SkeletonBodyText />;
    }

    return (
      <Container pageProps={{
        title: 'Mystery Grail',
        subtitle: 'Custom app build by Sunbowl',
        fullWidth: true,
      }}>
        <React.Fragment>
          <Layout.Section>
            <Card title="Welcome" sectioned>
              <pre>
                {JSON.stringify(user, null, 2)}
              </pre>
            </Card>
          </Layout.Section>

        </React.Fragment>
      </Container>
    );
  }
}
export default Debug;
